import { render, staticRenderFns } from "./ThemeGroupbuyingList.vue?vue&type=template&id=2d46c48e&"
import script from "./ThemeGroupbuyingList.vue?vue&type=script&lang=js&"
export * from "./ThemeGroupbuyingList.vue?vue&type=script&lang=js&"
import style0 from "./ThemeGroupbuyingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports